import React from 'react';
import { buildStructuredData } from './seoConfig';

export default function StructuredData({ mode, keyword, extras = {} }) {
  const schemas = buildStructuredData(mode, keyword, extras);

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
